import React from 'react';
import ProcessingFlow from '../components/processing/ProcessingFlow';
import { ProcessingProvider } from '../contexts/ProcessingContext';

export default function ProcessPage() {
  return (
    <ProcessingProvider>
      <ProcessingFlow />
    </ProcessingProvider>
  );
}